import { LeadSubmissionPayload } from '@/types';

/**
 * Submit a lead to the BFF API endpoint.
 * 
 * This function calls the Vercel BFF endpoint (/api/generate-lead) instead of 
 * calling the FastAPI backend directly. The BFF handles authentication and 
 * forwards the request securely to the backend.
 * 
 * Architecture:
 * Frontend (this code) → Vercel BFF (/api/generate-lead) → FastAPI Backend
 *                       [API key added here]            [validates API key]
 * 
 * @param payload - The lead data to submit
 * @returns Promise with the response data
 * @throws Error if submission fails
 */
export const submitLead = async (
  payload: LeadSubmissionPayload,
): Promise<any> => {
  // Call the BFF endpoint (relative URL)
  // No authentication needed from the client side - the BFF handles it
  const response = await fetch('/api/generate-lead', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ 
      error: 'Unknown error occurred' 
    }));
    
    throw new Error(
      error.error || 
      error.detail || 
      'Error submitting lead. Please try again.'
    );
  }

  return response.json();
};

